/**
 * Derive a human-friendly preview line for a message being quoted in a reply.
 *
 * Voice messages store their filename (e.g. "voice_123.webm") as the message
 * `content`, so a naive `replyTo.content` shows a useless filename. This helper
 * prefers the voice transcription when available and otherwise returns a clear
 * media label ("Voice message", "Photo", "Video", or the cleaned attachment
 * name) instead of a raw file path.
 */
export function getReplyPreviewText(msg) {
  if (!msg) return '';
  if (msg.transcription) return msg.transcription;

  const type = (msg.file_type || '').toLowerCase();
  const name = msg.file_name || '';
  const isVoice =
    type.startsWith('audio/') ||
    /\.(webm|mp3|m4a|ogg|wav|aac|mpga|mpeg)$/i.test(name) ||
    /voice/i.test(name);
  if (isVoice) return 'Voice message';

  const isImage = type.startsWith('image/') || /\.(jpe?g|png|gif|webp|heic|heif|bmp)$/i.test(name);
  if (isImage) return 'Photo';

  const isVideo = type.startsWith('video/') || /\.(mp4|mov|avi|mkv|3gp)$/i.test(name);
  if (isVideo) return 'Video';

  if (msg.file_url || msg.message_type === 'file') {
    // Strip a leading timestamp/uuid prefix from the stored filename.
    return name ? name.replace(/^\d+[_-]/, '') : 'Attachment';
  }
  return msg.content || '';
}
